import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dashboard-stats" }
const _hoisted_2 = { class: "investigator-summary" }
const _hoisted_3 = { class: "summary-stats" }
const _hoisted_4 = { class: "stat" }
const _hoisted_5 = { class: "stat-top" }
const _hoisted_6 = {
  key: 0,
  class: "fas fa-circle fa-lg yellow"
}
const _hoisted_7 = {
  key: 1,
  class: "fal fa-exclamation-triangle fa-lg orange"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "Total no of investigations", -1)
const _hoisted_9 = { class: "stat" }
const _hoisted_10 = { class: "stat-top" }
const _hoisted_11 = {
  key: 0,
  class: "fas fa-circle fa-lg yellow"
}
const _hoisted_12 = {
  key: 1,
  class: "fal fa-exclamation-triangle fa-lg orange"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "Standard investigations", -1)
const _hoisted_14 = { class: "stat" }
const _hoisted_15 = { class: "stat-top" }
const _hoisted_16 = {
  key: 0,
  class: "fas fa-circle fa-lg yellow"
}
const _hoisted_17 = {
  key: 1,
  class: "fal fa-exclamation-triangle fa-lg orange"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, "Cause driven investigations", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "summary-right-side" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, "Other quick notes", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.investigatorDetails.totalRoutines < 40 && _ctx.investigatorDetails.totalCauseDrivens < 3)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6))
              : (_openBlock(), _createElementBlock("i", _hoisted_7)),
            _createElementVNode("h2", null, _toDisplayString(_ctx.investigatorDetails.totalInvestigations), 1)
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.investigatorDetails.totalRoutines < 40)
              ? (_openBlock(), _createElementBlock("i", _hoisted_11))
              : (_openBlock(), _createElementBlock("i", _hoisted_12)),
            _createElementVNode("h2", null, _toDisplayString(_ctx.investigatorDetails.totalRoutines), 1)
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.investigatorDetails.totalCauseDrivens < 3)
              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
              : (_openBlock(), _createElementBlock("i", _hoisted_17)),
            _createElementVNode("h2", null, _toDisplayString(_ctx.investigatorDetails.totalCauseDrivens), 1)
          ]),
          _hoisted_18
        ]),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("ul", null, [
          (!_ctx.isPortalOffline)
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                (_ctx.leaveScheduled > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.leaveScheduled) + " leave scheduled", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "No leave scheduled"))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isPortalOffline)
            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                (_ctx.investigatorDetails.totalMissingTime > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$calculateHours(_ctx.investigatorDetails.totalMissingTime)) + " of overdue timesheets", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, "Timesheet up to date"))
              ]))
            : _createCommentVNode("", true),
          _hoisted_27
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary sml mr-2",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.goToInvestigations && _ctx.goToInvestigations(...args)))
        }, [
          _createTextVNode(" View investigations "),
          _hoisted_28
        ])
      ])
    ])
  ]))
}